import { ReactElement } from "react"

import CreateEbDeviceForm from "../../../../components/devices/lct/eb/createEbDeviceForm"
import NewEbDeviceVersionProvider from "../../../../components/devices/lct/eb/providers/newEbDeviceVersionProvider"

const NewEbDeviceVersion = (): ReactElement => (
    <NewEbDeviceVersionProvider>
        <CreateEbDeviceForm />
    </NewEbDeviceVersionProvider>
)

export default NewEbDeviceVersion
